import React from 'react';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeButton from '../../../Button/SubscribeButton';
export var TierButton = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    return (React.createElement(ActionBarItemWrapper, null,
        React.createElement(SubscribeButton, { className: className, tier: deviation, withPrice: true })));
};
TierButton.displayName = 'TierButton';
export default TierButton;
//# sourceMappingURL=TierButton.js.map